import { HOST_URL } from '@/constants';
import React from 'react';
import languages from '../../utils/languages.js';
/**
 *  根据传入的alternatives来生成 hreflang, 用于CMS页面
 */
export const getHrefLangList = (alternatives = [], selfFullSlug = '') => {
  const result = [];
  let defaultHref = '';
  if (selfFullSlug.startsWith('en/')) {
    defaultHref = `${HOST_URL}/${selfFullSlug}`;
  }
  const publishedAlternatives = alternatives.filter((item) => {
    if (item.published && item.full_slug.startsWith('en/')) {
      defaultHref = `${HOST_URL}/${item.full_slug}`;
    }

    return item.published;
  });

  result.push(
    ...publishedAlternatives.map((item) => {
      const lng = item.full_slug.split('/')[0] || '';
      return <link key={item.full_slug} rel="alternate" href={`${HOST_URL}/${item.full_slug}`} hrefLang={lng} />;
    }),
  );

  defaultHref && result.push(<link rel="alternate" href={defaultHref} hrefLang="x-default" />);
  selfFullSlug &&
    result.push(<link rel="alternate" href={`${HOST_URL}/${selfFullSlug}`} hrefLang={selfFullSlug.split('/')?.[0]} />);

  return result;
};

/**
 * 根据传入的uri生成 hreflang，用于本地生成的多语言页面
 * @param uri 当前的uri
 * @returns hreflang 数组
 */
export const getHrefLangListLocal = (uri = '', supportLanguages = languages.SUPPORT_LANGUAGES) => {
  const result = [];
  supportLanguages.forEach((lang) => {
    result.push(<link rel="alternate" href={`${HOST_URL}${lang === 'ja' ? '' : `/${lang}`}${uri}`} hrefLang={lang} />);
  });
  result.push(<link rel="alternate" href={`${HOST_URL}/en${uri}`} hrefLang="x-default" />);
  return result;
};
